import React, { useEffect } from "react";
import { CustomButton, MainHeader, WithdrawRequestedModal } from "../../components";
import { Container, HStack, Panel, Placeholder, VStack } from "rsuite";

import styles from "./TransferMoney.module.scss";
import { Link } from "react-router-dom";

import { IoIosArrowRoundForward } from "react-icons/io";

export default function TransferMoney() {
  return (
    <div className={`wrapper ${styles.transfer__money}`}>
      <div className="vertical-column-layout">
        <div className="vertical-column-top">
          <MainHeader title="Transfer Money" />

          <Panel shaded style={{ borderRadius: 15 }}>
            <VStack alignItems="stretch" spacing={20}>
              <HStack justifyContent="space-between">
                <div className={styles.title}>Active Balance</div>
                <div className={styles.value}>₹1,000</div>
              </HStack>
              <HStack justifyContent="space-between">
                <div className={styles.title}>Transferred Balance</div>
                <div className={styles.value}>₹4,000</div>
              </HStack>
              <HStack justifyContent="space-between">
                <div className={styles.title}>Total Earned</div>
                <div className={styles.value}>₹5,000</div>
              </HStack>
            </VStack>
          </Panel>

          <br />

          <Panel shaded style={{ borderRadius: 15 }}>
            <div className={styles.value}>₹1,000</div>
          </Panel>

          <div className={styles.tax__amount}>-₹200 (Tax Deducted at Source)</div>
        </div>

        <WithdrawRequestedModal />

        <HStack justifyContent="space-between" className={styles.total__amount}>
          <div>
            <p>Total</p>
            <div className={styles.amount}>₹ 760.00</div>
          </div>
          <div>
            <CustomButton text="Withdraw" endIcon={<IoIosArrowRoundForward size={30} />} />
          </div>
        </HStack>
      </div>
    </div>
  );
}
